<div class="contentContainer">

    <!------------------------------------------------------------------------------ header -->

    <div fxLayout="row" fxLayoutAlign="space-between center" class="headerContentContainer">
        <div fxLayout="row">
            <div fxLayoutAlign="center center" class="grayLink" (click)="routeService.goBack()">
                <mat-icon class="linkIcon ft22">arrow_back</mat-icon>
            </div>
            <div>
                <h6 class="mgl10 ft500 ft16 mgb0 gray-9"> Lista instructores</h6>
            </div>
        </div>
        <div fxLayout="row">
            <div routerLink="/admin/form-instructores" class="mgl10 sqChip ft12 ft500 backGray9 shadow20">
                Agregar
            </div>
            <div routerLink="/admin/sign-up-instructor" class="mgl10 sqChip ft12 ft500 backGray9 shadow20">
                Sign up instructor
            </div>
        </div>
    </div>

    <!------------------------------------------------------------------------------ Table -->

    <div class="tableContainer">

        <table class="w-100">

            <!-- Table heaeder -->
            <tr class="tableHeaderContainer">
                <th>Nombre</th>
                <th>ID</th>
                <th>ID usuario Inst.</th>
                <th>Empresa</th>
                <th>Cant. Cursos</th>
                <th>Cant. Ventas</th>
                <th class="w-10">Publicado</th>
                <th>Fecha creación</th>
            </tr>

            <!-- Table data -->
            <tr *ngFor="let item of array; let i=index">
                <td>
                    <div fxLayoutAlign="space-between">
                        <a routerLink="/instructor/{{item.id}}"
                            class="mgl05 blueLink undrl ft500 ft12">{{item.nombre}}</a>
                        <mat-icon routerLink="/admin/form-instructores/{{item.id}}"
                            class="cursorPointer gray-4 ft18 linkIcon">edit
                        </mat-icon>
                    </div>
                </td>
                <td class="centertext">{{item.id}}</td>
                <td class="centertext">{{item.usuarioInstructorId}}</td>
                <td class="centertext">
                    <a routerLink="/empresa/{{item.empresaId}}"
                        class="mgl05 blueLink undrl ft500 ft12">{{item.empresaNombre}}</a>
                </td>

                <td class="centertext">{{item.cantCursos}}</td>
                <td class="centertext">{{item.cantVentas}}</td>
                <td class="centertext">
                    <div fxLayoutAlign="center center">
                        <div class="sqChip ft11 backGreen5 cursorDefault" *ngIf="item.publicado==true">
                            Publicado
                        </div>
                        <div class="sqChip ft11 backYellow5 cursorDefault" *ngIf="item.publicado==false">
                            Borrador
                        </div>
                    </div>
                </td>
                <td class="centertext">
                    <span *ngIf="item.fechaCreacion" class="ft11">{{item.fechaCreacion.toDate() | date}}</span>
                </td>
            </tr>
        </table>
    </div>
</div>